import { motion, useReducedMotion } from "motion/react";
import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function NearbyCTA() {
  const reduced = useReducedMotion();

  return (
    <section
      aria-labelledby="nearby-final-cta-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-20 md:py-28">
        <Reveal>
          <Eyebrow tone="light">Stay Close to the Adventure</Eyebrow>
        </Reveal>
        <h2 id="nearby-final-cta-heading" className="display-xl mt-6 max-w-[16ch]">
          <MaskReveal>Explore All Day.</MaskReveal>
          <MaskReveal delay={0.08}>Come Home to Auburn.</MaskReveal>
        </h2>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            From river canyons and historic Gold Country to local flavors and Sierra mountain
            adventures, Auburn RV Resort puts you in the perfect position to experience more of
            Northern California.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
              Check Availability
            </ResortLink>
            <ResortLink variant="onDark" href="/rates/" className="w-full sm:w-auto">
              View Rates
            </ResortLink>
          </div>
          <p className="eyebrow mt-8 text-primary-foreground/60">
            Full Hookups · Daily · Weekly · Monthly · Big Rig Friendly · Pet Friendly
          </p>
        </Reveal>
      </div>
    </section>
  );
}
